import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";

interface Request {
  data: string,
}

export interface SubmitReceivingSignatureResponse {
  emailTickets: boolean,
  userEmail?: string,
}

const useSubmitReceivingSignature = (stagedPurchaseOrderId: string, options?: RequestOptions<SubmitReceivingSignatureResponse>) =>
  useUserOrKioskRequest<Request, SubmitReceivingSignatureResponse>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/submitSignature`
  }, options);

export default useSubmitReceivingSignature;